module.exports = __webpack_public_path__ + "static/media/mobile_bg_1.0f56d7f5.webp";